import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationService } from '../../shared/navigation/navigation.service';
import { MenuItem } from 'primeng/api';
import { TranslationService } from '../../shared';
import { TitleCasePipe } from '../../shared/pipes/titlecase.pipe';

@Component({
  selector: 'wl-dashboard-neo-membership-reports',
  templateUrl: 'dashboard-neo-membership-reports.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [TitleCasePipe],
    standalone: false
})
export class DashboardNeoMembershipReportsComponent implements OnInit {
  public engagementReportsItems: MenuItem[];
  public selectedEngagementReport: MenuItem;
  public memberReportsItems: MenuItem[];

  public constructor(
    private _navigationService: NavigationService,
    private _translationService: TranslationService,
    private _titleCasePipe: TitleCasePipe
  ) {}

  ngOnInit() {
    Promise.all([
      this._translationService.getTitlecase('dashboard.membership-activity.reports.event-participation'),
      this._translationService.getTitlecase('dashboard.membership-activity.reports.contact-record-engagement'),
      this._translationService.getTitlecase('dashboard.membership-activity.reports.non-dues-revenue-engagement'),
      this._translationService.getTitlecase('dashboard.membership-activity.reports.referral-rate-engagement'),
      this._translationService.getTitlecase('dashboard.membership-activity.reports.committee-participation'),
    ]).then(([eventParticipation, contactRecord, nonDuesRevenue, referralRate, committeeParticipation]) => {
      this.engagementReportsItems = [
        {
          id: 'member-activity-event-participation-engagement-report-link',
          label: eventParticipation,
          command: (event) => {
            this._navigationService.navigateToEventParticipationEngagementReport();
          },
        },
        {
          id: 'member-activity-contactRecord-engagement-report-link',
          label: contactRecord,
          command: (event) => {
            this._navigationService.navigateToContactEngagementReport();
          },
        },
        {
          id: 'member-activity-non-dues-engagement-report-link',
          label: nonDuesRevenue,
          command: (event) => {
            this._navigationService.navigateToNonDuesRevenueEngagementReport();
          },
        },
        {
          id: 'member-activity-referral-rate-engagement-report-link',
          label: referralRate,
          command: (event) => {
            this._navigationService.navigateToReferralRateEngagementReport();
          },
        },
        {
          id: 'member-activity-committee-participation-engagement-report-link',
          label: committeeParticipation,
          command: (event) => {
            this._navigationService.navigateToCommitteeParticipationEngagementReport();
          },
        },
      ];
    });

    Promise.all([
      this._translationService.getTitlecase('dashboard.membership-activity.reports.members-joined'),
      this._translationService.getTitlecase('dashboard.membership-activity.reports.member-retention'),
      this._translationService.getTitlecase('dashboard.membership-activity.reports.members-dropped'),
    ]).then(([membersJoined, memberRetention, membersDropped]) => {
      this.memberReportsItems = [
        {
          label: membersJoined,
          command: () => this.openMembersJoinedReport(),
        },
        {
          label: memberRetention,
          command: () => this.openMemberRetentionReport(),
        },
        {
          label: membersDropped,
          command: () => this.openMembersDroppedReport(),
        },
      ];
    });
  }

  public openMembersJoinedReport() {
    this._navigationService.navigateToMembersJoinedReport();
  }

  public openMemberRetentionReport() {
    this._navigationService.navigateToMemberRetentionReport();
  }

  public openMembersDroppedReport() {
    this._navigationService.navigateToMembersDroppedReport();
  }
}
